import { Snackbar } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { createContext, useCallback, useContext, useState } from 'react';

type TypeProps = 'success' | 'error';

type TypeToast = {
  visible: boolean;
  type: TypeProps | null;
  message: string | null;
  description?: string | null;
};

interface ToastContextData {
  toast: TypeToast;
  setToast: (toast: TypeToast) => void;
}

const initialToast: TypeToast = {
  visible: false,
  type: null,
  message: null,
};

const initialContext = {
  toast: initialToast,
  setToast: () => {},
};

const ToastContext = createContext<ToastContextData>(initialContext);

export function ToastMessageProvider({ children }) {
  const [toast, setToast] = useState(initialToast);

  const handleClose = useCallback(() => {
    setToast(current => ({ ...current, visible: false }));
  }, []);

  return (
    <ToastContext.Provider value={{ toast, setToast }}>
      {children}
      <Snackbar
        open={toast.visible}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleClose}
          severity={toast.type === 'error' ? 'error' : 'success'}
          variant='filled'
        >
          {toast.message}
        </Alert>
      </Snackbar>
    </ToastContext.Provider>
  );
}

export const useToastValue = () => useContext(ToastContext);
